const GA_MEASUREMENT_ID = 'G-WPX77W6Q4R';

export const getGaClientId = () =>
  new Promise(resolve => {
    if (typeof window.gtag !== 'function') {
      resolve(null);
      return;
    }

    window.gtag('get', GA_MEASUREMENT_ID, 'client_id', clientId => {
      resolve(clientId || null);
    });
  });
